import TextEditor from 'components/text-editor';
import Button from 'components/ui/button';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { IoIosClose } from 'react-icons/io';
import { toast } from 'react-toastify';

interface Props {
  sendMessage: (data: { message: string; id: string }) => void;
  close: () => void;
  data: { message: string; id: string };
}

export default function ModalEdit(data: Props) {
  const { sendMessage, close, data: itemData } = data;

  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const minTextLength = 100;
  const maxTextLength = 600;

  const messageRef = useRef<any>();

  function handleChangeMessage(content: string, contentLength: any) {
    setMessage(content);
    setMessageLength(contentLength);
  }

  const filterMessage = useCallback(() => {
    if (!message || !messageLength || messageLength.textLength < minTextLength || messageLength.fullLength > maxTextLength)
      return;

    sendMessage({ message, id: itemData.id });
  }, [itemData.id, message, messageLength, sendMessage]);

  useEffect(() => {
    if (!!itemData?.message) {
      setMessage(itemData.message);
    }
  }, [itemData]);

  return useMemo(() => {
    return (
      <div className="user-tutorial fixed bg-black bg-opacity-40 top-0 left-0 w-screen h-screen flex justify-center items-center">
        <div className="relative border-2 border-solid border-electric-blue bg-oxford-blue rounded-lg p-4 lg:w-[60vh] w-[90vw]">
          <Button
            color="primary"
            className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center z-10"
            onClick={() => close()}
          >
            <IoIosClose color="white" size={30} />
          </Button>

          <div className="w-full">
            <p className="block text-xl text-white  leading-none mb-3">Edite o seu reconhecimento</p>

            <div className="w-full bg-transparent">
              {message ? (
                <TextEditor
                  initialValue={message}
                  onChange={handleChangeMessage}
                  minLength={minTextLength}
                  maxLength={maxTextLength}
                  className="h-[40vh] lg:h-[250px]"
                />
              ) : null}

              {messageLength && messageLength.fullLength > 0 && messageLength.textLength < minTextLength && (
                <p className="text-yellow mt-4">
                  Para continuar, insira pelo menos {minTextLength} caracteres no campo de texto, sem contar os emojis.
                </p>
              )}

              {messageLength && messageLength.fullLength > 0 && messageLength.fullLength > maxTextLength && (
                <p className="text-yellow mt-4">O texto inserido ultrapassou o limite máximo de {maxTextLength} caracteres.</p>
              )}

              <div className="flex justify-center mt-4">
                <button
                  disabled={
                    !message ||
                    !messageLength ||
                    messageLength.textLength < minTextLength ||
                    messageLength.fullLength > maxTextLength
                  }
                  onClick={() => filterMessage()}
                  className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                >
                  <p className="font-bold text-sm leading-none uppercase">Enviar</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }, [close, filterMessage, message, messageLength]);
}
